export default __webpack_public_path__ + "static/media/pd10.41e68099.jpg";